import React from 'react'

import logo from '../../assets/logos/voyages.svg'

const links = [
  {
    text: 'Contact Us',
    url: 'https://www.ayersrockresort.com.au/contact',
  },
  {
    text: 'Website Feedback',
    url: 'mailto:emktmgr@voyages.com.au',
  },
  {
    text: 'Trade',
    url: 'https://trade.voyages.com.au/',
  },
  {
    text: "FAQ's",
    url: 'https://www.ayersrockresort.com.au/our-story/faq',
  },
  {
    text: 'Site Map',
    url: 'https://www.ayersrockresort.com.au/sitemap',
  },
  {
    text: 'Terms & Conditions',
    url: 'https://www.ayersrockresort.com.au/terms-conditions',
  },
  {
    text: 'Privacy Policy',
    url: 'https://www.ayersrockresort.com.au/terms-and-conditions/privacy-policy',
  },
]

const Footer = () => {
  return (
    <footer
      id="footer"
      className="flex-wrap justify-between p-8 bg-black md:bg-dark lg:flex"
    >
      <a
        href="https://www.ayersrockresort.com.au"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={logo} alt="voyages" className="mx-auto" />
      </a>
      <div className="flex-auto">
        <div className="flex flex-wrap justify-center lg:justify-end">
          {links.map((link) => (
            <a
              className="font-body tracking-wider text-white no-underline font-bold p-2"
              key={link.text + link.url}
              href={link.url}
            >
              {link.text}
            </a>
          ))}
        </div>
        <p className="font-body text-offWhite m-0 text-xs text-center lg:text-right">
          Copyright {new Date().getFullYear()} Voyages Indigenous Tourism
          Australia. All rights reserved.
        </p>
      </div>
    </footer>
  )
}

export default Footer
